function dateFormatter(mark, value) {                                       // форматирование даты в зависимости от маркера
    const str = value
    if (str && str.length > 8) {
        if (mark === '-') {
            return str.split('-').reverse().join('.')                // дд.мм.гггг
        }
        
        if (mark === '.') {
            return str.split('.').reverse().join('-')                // гггг-мм-дд
        }
    } else {
        return str
    }
}


export {
    dateFormatter,
}
